// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__S1UDW","container":"styles_container__ndUq3"};